module.exports = __webpack_public_path__ + "img/img20.c363b118.png";